import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartLine = () => {
  return (
    <g>
      <path d="m13.7813.8164a2.1616 2.1616 0 0 0 -2.1582 2.1592 2.1377 2.1377 0 0 0 .46 1.3164l-2.5626 4.1357-2.3916-3.0312a.71.71 0 0 0 -.6358-.2832.7482.7482 0 0 0 -.5957.36l-3.2774 5.4325a2.1577 2.1577 0 1 0 1.757 2.1186 2.1381 2.1381 0 0 0 -.4762-1.3359l2.7213-4.5118 2.3838 3.0205a.75.75 0 0 0 1.2266-.0693l3.1209-5.0364a2.159 2.159 0 1 0 .4279-4.2751zm-11.5625 12.9668a.7588.7588 0 1 1 .7578-.7588.7589.7589 0 0 1 -.7578.7588zm11.5625-10.0488a.7588.7588 0 1 1 .7588-.7588.7587.7587 0 0 1 -.7588.7588z" />
    </g>
  );
};

export default withIcon(IconChartLine);
